import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useTileStyles = createUseStyles({
  tileWrapper: {
    width: 'calc(25% - 30px)',
    minWidth: 250,
    padding: '1.5rem',
    backgroundColor: '#fff',
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover > header': {
      borderBottom: `2px solid ${colors.primary1}`
    },
    '&:hover': {
      boxShadow: '0 0 10px rgba(0,0,0,0.12)'
    },
    '&.disabled': {
      pointerEvents: 'none',
      opacity: 0.4
    }
  },
  '@media (max-width: 700px)': {
    tileWrapper: {
      width: '100%'
    }
  },
  tileTitle: {
    borderBottom: `2px solid ${colors.gray100}`,
    paddingBottom: '1rem',
    fontSize: '1.25rem'
  },
  tileText: {
    margin: '1rem 0'
  }
})

export { useTileStyles }
